import {IFormFilesInterface} from "../Shared/form-files.interface";

export type IAgFormNinthSectionInterface = {
    SupportingDocuments?: Array<IFormFilesInterface>,
}

export const AgFormNinthSectionInitialState = (): IAgFormNinthSectionInterface => ({
    SupportingDocuments: undefined
})